import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastService } from 'src/app/core/toast.service';
import { ApiEntregadorService } from 'src/app/dao/api_entregador.service';
import { Motoboy } from 'src/app/model/motoboy';

@Component({
  selector: 'app-motoboy',
  templateUrl: './motoboy.page.html',
  styleUrls: ['./motoboy.page.scss'],
  providers: [MessageService, ConfirmationService]
})
export class MotoboyPage implements OnInit {
  freteDialog: boolean;

  fretes: Motoboy[];

  frete: Motoboy;

  selectedfretes: Motoboy[];

  submitted: boolean;

  ativos;

  // tslint:disable-next-line: max-line-length
  constructor(private motoboyService: ApiEntregadorService, private toast: ToastService, private confirmationService: ConfirmationService) {}

  async ngOnInit() {
    this.frete = new Motoboy();
    this.motoboyService.listarTodas().then(data => this.fretes = data);
    const result = await this.motoboyService.listarTodas();
    this.ativos = [
      {nome:'ATIVO', valor: 1},
      {nome:'INATIVO', valor: 0}
    ]
    this.carregarAtivos();
  }


  carregarAtivos() {
        this.ativos = this.ativos.map(c => {
          return ({ label: c.nome, value: c.valor });
          // tslint:disable-next-line: align
        });
  }

  openNew() {
    // tslint:disable-next-line: new-parens
    this.frete = {};
    this.submitted = false;
    this.freteDialog = true;
  }

  deleteSelectedfretes() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar os fretes selecionados?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.fretes = this.fretes.filter(val => !this.selectedfretes.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedfretes.length; i++) {
          const result = this.motoboyService.excluir(this.selectedfretes[i].id);
        }
        this.selectedfretes = null;
        this.toast.showSucess('Fretes Excluídos com Sucesso!');
      }
    });
  }

  editfrete(frete: Motoboy) {
    this.frete = {...frete};
    this.freteDialog = true;
  }

  deletefrete(frete: Motoboy) {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar o frete ' + frete.nome + '?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const result = this.motoboyService.excluir(frete.id);
        this.fretes = this.fretes.filter(val => val.id !== frete.id);
        this.frete = {};
        this.toast.showSucess('Frete Excluído com Sucesso!');
      }
    });
  }

  hideDialog() {
    this.freteDialog = false;
    this.submitted = false;
  }

 async savefrete() {
    this.submitted = true;

    if (this.frete.nome.trim()) {
      if (this.frete.id) {
        // tslint:disable-next-line: radix
        this.fretes[this.findIndexById(parseInt(this.frete.id))] = this.frete;
        //this.frete.ativo = true;
        this.motoboyService.atualizar(this.frete);
        this.toast.showSucess('Frete Atualizado com Sucesso!');
      } else {
        const result = await this.motoboyService.adicionar(this.frete);
        this.fretes.push(result);
        this.toast.showSucess('Frete Cadastrado com Sucesso!');
      }

      this.fretes = [...this.fretes];
      this.freteDialog = false;
      this.frete = {};
    }
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.fretes.length; i++) {
      // tslint:disable-next-line: radix
      if (parseInt(this.fretes[i].id) === id) {
        index = i;
        break;
      }
    }

    return index;
  }
}
